class DataToMail {
  constructor() {
    this.target = document.querySelectorAll('[data-target="data-to-mail"]');
    if (Array.from(this.target)[0]) {
      this._init();
    }
  }

  _init() {
    var title = "Candidature spontannée";
    if (document.getElementById("offre_title").textContent) {
      title = document.getElementById("offre_title").textContent;
    }
    document.getElementById("job_mail").value = title;
  }
}

export let dataToMail = new DataToMail();
